import React, { Component } from 'react';
import { Slider } from 'antd'
class Criteria extends Component {
    render() {
        return (
            <div className="Criteria">
                <div className="SectionTitle" >Criteria</div>
                <div className="SectionContent" >
                    <div className="CriteriaItem">
                        <div className="Name">Load</div>
                        <div className="Value">
                            <Slider value={this.props.weights.load} onChange={e => this.props.onChangeWeight({ load: e })} />
                        </div>
                    </div>
                    <div className="CriteriaItem">
                        <div className="Name">Constructability</div>
                        <div className="Value">
                            <Slider value={this.props.weights.cstru} onChange={e => this.props.onChangeWeight({ cstru: e })} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Criteria
